module.exports = __webpack_public_path__ + "assets/backIcon.8d046a28.svg";